module.exports = __webpack_public_path__ + "static/media/P_Hendrix.e1375783.jpg";